import Vue from "vue";
import App from "./App.vue";
import axios from "axios";
import VueRouter from "vue-router";
import router from "./router";
import store from "./store";
import DefaultLayout from "./layouts/DefaultLayout.vue";
import AuthLayout from "./layouts/AuthLayout.vue";
import BlankLayout from "./layouts/BlankLayout.vue";
import Columnbanner from "@/components/Columnbanner.vue";
import ColumnTitle from "@/components/ColumnTitle.vue";
import ColumnRoute from "@/components/ColumnRoute.vue";
import { SkeletonItem } from "element-ui";

import "./assets/scss/element-variables.scss";
import "./assets/scss/index.scss";

import "./permission";

Vue.component("el-skeleton-item", SkeletonItem);

Vue.component("layout-default", DefaultLayout);
Vue.component("layout-auth", AuthLayout);
Vue.component("layout-blank", BlankLayout);

// 栏目banner
Vue.component("Columnbanner", Columnbanner);
// 栏目标题
Vue.component("ColumnTitle", ColumnTitle);
// 栏目二级路由
Vue.component("ColumnRoute", ColumnRoute);

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;

Vue.use(VueRouter);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
